import { render, staticRenderFns } from "./Travel.vue?vue&type=template&id=0e656eb2&scoped=true"
import script from "./Travel.vue?vue&type=script&lang=js"
export * from "./Travel.vue?vue&type=script&lang=js"
import style0 from "./Travel.vue?vue&type=style&index=0&id=0e656eb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e656eb2",
  null
  
)

export default component.exports